module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Audio-4"
  }, [(_vm.frashState) ? _c('reportTemp', {
    attrs: {
      "repType": 1
    },
    on: {
      "go-frash": _vm.frashCtrls
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8872f4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/provinceRole/electPgress/electReport.vue
// module id = 1807
// module chunks = 1